angular.module("ainapp")
    .controller("employeeLoanListController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {

            $scope.PageName = "Employee Loan List";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                    IsLinkPending: false,
                };
            }
            $scope.init();


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        //                        o.data.Keyword = $scope.filter.Keyword;
                        //                        o.data.IsLinkPending = $scope.filter.IsLinkPending;
                        MainService.EmployeeLoansInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            "Employee.Name": {
                                type: "date",
                            },
                            "LoanType.Name": {
                                type: "date",
                            },
                            VoucherNo: {
                                type: "string",
                            },
                            TotalAmount: {
                                type: "number",
                            },
                            ApprovedAmount: {
                                type: "number",
                            },
                            NoOfInstallments: {
                                type: "number",
                            },
                            Status: {
                                type: "string",
                            },
                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [
                    {
                        field: "VoucherNo",
                        title: "#",
                    },
                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                    },
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        headerTemplate: "{{LanguageData.Employee}}",
                    },
                    {
                        field: "LoanType.Name",
                        title: "Loan Type",
                    },
                    {
                        field: "TotalAmount",
                        title: "Total Amount",
                    },
                    {
                        field: "ApprovedAmount",
                        title: "Approved Amount",
                    },
                    {
                        field: "NoOfInstallments",
                        title: "No Of Installments ",
                    },
                    {
                        field: "InstallmentAmount",
                        title: "Installment Amount",
                    },
                    {
                        field: "Status",
                        title: "Status",
                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='Delete(dataItem)'></button>",
                        width: '80px'
                    },


                                        ],
            };


            $scope.Edit = function (data) {
                $state.go("editEmployeeLoan", {
                    VoucherId: data.Id
                })
            };

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }


            $scope.Delete = function (data) {
                $scope.SelectedDataForDelete = data;
                $('#deleteModal').modal('show');
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteEmployeeLoan($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                    $scope.load = false;
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



                }])
